module.exports = {
  flags: {
    PARTIAL_HYDRATION: false,
    PARALLEL_SOURCING: true,
    DEV_SSR: false,
  },
  siteMetadata: {
    //siteUrl: require('./marketConfig').getSiteConfig().siteUrl,
    //siteUrl: require('./marketConfig').getSiteConfig().siteUrl,
    siteUrl: process.env.GATSBY_SITE_SITEURL || 'https://www.alpresor.se',
  },
  //trailingSlash: 'always',

  plugins: [
    'gatsby-plugin-postcss',
    'gatsby-plugin-sitemap',
    {
      resolve: 'gatsby-plugin-manifest',
      options: {
        icon: 'src/images/logo.png',
      },
    },
    {
      resolve: 'gatsby-source-storyblok',
      options: {
        accessToken: 'PAAoII0t4laR9ZRhchr3Qwtt',
        version: 'published',
        localAssets: false,
        resolveLinks: 'link',
        //languages: [process.env.GATSBY_STORYBLOK_LANGUAGE],
        // languages: [process.env.GATSBY_STORYBLOK_LANGUAGE || 'fi'],
        // languages: [process.env.GATSBY_STORYBLOK_LANGUAGE || 'no'],
      },
    },
    {
      resolve: 'gatsby-source-graphql',
      options: {
        typeName: 'ETHEL',
        fieldName: 'ethel',

        //dev
        //url: 'https://api-web.se.dev.ethel.alpresor.net/graphql',

        //prod
        url: 'https://api-web.alpresor.se/graphql',

        headers: {
          //dev
          //Authorization: `ApiKey acfd149c-06fd-4913-bbbb-48f1559b3531`,
          //prod
          Authorization: `ApiKey 8c625aaa-bab5-49b3-b813-d16bd1eed2e4`,

          //
          //Authorization: `ApiKey ${process.env.GITHUB_TOKEN}`,
        },
      },
    },
    {
      resolve: 'gatsby-plugin-google-tagmanager',
      options: {
        id: 'GTM-M9W8PM3',
        includeInDevelopment: true,
      },
    },
  ],
  headers: [
    {
      source: `*`,
      headers: [
        {
          key: `Content-Security-Policy`,
          value: `frame-ancestors https://app.storyblok.com`,
        },
        {
          key: `X-Frame-Options`,
          value: `ALLOW-FROM https://app.storyblok.com`,
        },
      ],
    },
  ],
};
